import { render, staticRenderFns } from "./LiveSDKV2.vue?vue&type=template&id=1d35c558&scoped=true&"
import script from "./LiveSDKV2.vue?vue&type=script&lang=ts&"
export * from "./LiveSDKV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d35c558",
  null
  
)

export default component.exports